import { ReadmeAspect } from './readme.aspect';

export default ReadmeAspect;
export type { ReadmeMain } from './readme.main.runtime';
export { ReadmeEnv } from './readme.env';

export { ReadmeAspect };
